export default __webpack_public_path__ + "static/media/easysetup.b64148c0.svg";